/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Step_4_TitleInputs */

const es_home_intro_step_4_title = /** @type {(inputs: Home_Intro_Step_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtené respuestas`)
};

const en_home_intro_step_4_title = /** @type {(inputs: Home_Intro_Step_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get answers`)
};

/**
* | output |
* | --- |
* | "Get answers" |
*
* @param {Home_Intro_Step_4_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_step_4_title = /** @type {((inputs?: Home_Intro_Step_4_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Step_4_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_step_4_title(inputs)
	return en_home_intro_step_4_title(inputs)
});
export { home_intro_step_4_title as "home.intro.step_4_title" }